// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2HeMP","additionalInfo":"AgreementModal_additionalInfo__2rIWu"};